import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useAppDispatch } from "../../app/hooks";
import { MessageThread } from "../../features/messages/models/MessageThread";
import { setThreadStaffOnly } from "../../features/messages/slice-extensions/messages-slice-extension";

interface StaffOnlyToggleProps {
  thread: MessageThread;
}

/** Staff only, Group and Session threads: members read, only instructors write while it is on. */
const StaffOnlyToggle = ({ thread }: StaffOnlyToggleProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [busy, setBusy] = useState(false);

  const toggle = async (staffOnly: boolean) => {
    setBusy(true);
    const result = await dispatch(setThreadStaffOnly({ threadId: thread.id, staffOnly }));
    setBusy(false);
    if (setThreadStaffOnly.rejected.match(result)) toast.error(t("messages.staffOnly.failed"));
  };

  return (
    <label className="flex shrink-0 cursor-pointer items-center gap-2 text-sm text-grey-20 dark:text-white">
      <input
        type="checkbox"
        checked={thread.staffOnly}
        disabled={busy}
        onChange={(e) => toggle(e.target.checked)}
        aria-describedby={thread.staffOnly ? `staff-only-hint-${thread.id}` : undefined}
      />
      <span>{t("messages.staffOnly.toggle")}</span>
    </label>
  );
};

export default StaffOnlyToggle;
